<template lang="pug">
Card.selections-card
  template(#header)
    .title {{ $t('selections.age.title') }} — {{noAge ? "Unknown" : `${ years } (${ age }’s)`}}
  template(#content)
    SliderCustom(
      v-model="age"
      v-model:disable="noAge"
      :step="10"
      :min="1890"
      :max="2020"
      :disableText="$t('selections.age.option')"
      :ariaLabel="$t('selections.age.title')"
      @update:modelValue="resetTypeAndTypology"
    )
</template>
<script lang="ts">
import {useSelections} from "@/store/selections";
import {computed, defineComponent, watch} from "vue";
import SliderCustom from "@/components/forms/components/SliderCustom.vue";
import {storeToRefs} from "pinia";
import Card from "primevue/card";

export default defineComponent({
  name: "AgeOfHome",
  components: {
    Card,
    SliderCustom,
  },
  setup() {
    const selections = useSelections();
    const {age, noAge} = storeToRefs(selections);
    const {resetTypeAndTypology} = selections;

    const years = computed(
        () =>
            Math.floor((new Date().getFullYear() - age.value) / 10) * 10 +
            " - " +
            Math.ceil((new Date().getFullYear() - age.value) / 10) * 10 +
            " years"
    );

    watch([age, noAge], () => resetTypeAndTypology());

    return {
      age,
      years,
      noAge,
      resetTypeAndTypology,
    };
  },
});
</script>
<style scoped lang="scss"></style>
